export const GENERAL_LABEL_COLOR = {
  Beige: '#F5E6CC',
  Blue: '#7CAAFF',
  Coffee: '#DEB887',
  Green: '#A8E6A3',
  Yellow: '#FFF3A1',
  Orange: '#FFC879',
  Purple: '#C9A9F4',
  Red: '#FFA7A7',
  Tosca: '#8AD7EF',
};
